<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex';
export default {
  name: 'App',
  created(){
    if(sessionStorage.getItem('user')){
      this.login(JSON.parse(sessionStorage.getItem('user')))
    }
	this.IsPC();
  }
  ,methods:{
    ...mapMutations(['login']),
	IsPC(){  
	     var userAgentInfo = navigator.userAgent;
	     var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");  
	     var flag = true;  
	     for (var v = 0; v < Agents.length; v++) {  
	         if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }  
	     }
		 if(!flag){
			 location.href = process.env.NODE_ENV;
		 }
	     
	  }
  }
}
</script>
<style>
@import url("../common/style/_style.scss");
@import url("../common/style/style.css");
html,body {
  width: 100%;
  margin: 0;
  padding: 0;
}
.fangda{
	transform: scale(1);
	transition: all 1s; 
}
.fangda:hover{
	transform: scale(1.1);
	transition: all 1s; 
}
body {
  box-sizing: border-box;

}
ul,li {
	list-style: none;
	padding:0;
	margin:0;
}

img {
	object-fit:cover;
  width: 100%;
  height: 100%;
}

.w-1200 {
  width: 1200px;
 margin: auto;
}
h4,h2,h3,dl,dt,dd,p,h5,h6 {
	padding:0;
	margin: 0;
}
.clearfix:after {
    clear:both;
    content:"";
    display:block;
    height:0;
    line-height:0;
    visibility:hidden;
}
.fl {
  float:left;
}
.fr {
  float:right;
}

.pages{
	height: 120px;	
	.active{
		background: #306BE3!important;
	}
	}
.back {
    position: absolute;
    bottom: 20px;
    left: 50px;
    z-index: 999;
}
.row-center{
	display: flex;
	justify-content: center;
	align-items: center;
}
.row-left{
	display: flex;
	justify-content: flex-start;
	align-items: center;
	
}
.row-between{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.only-one{
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.only-two{
	text-overflow: -o-ellipsis-lastline;
	 overflow: hidden;
	 text-overflow: ellipsis;
	 display: -webkit-box;
	 -webkit-line-clamp: 2;
	 line-clamp: 2;
	 -webkit-box-orient: vertical;
}
.only-four{
	text-overflow: -o-ellipsis-lastline;
	 overflow: hidden;
	 text-overflow: ellipsis;
	 display: -webkit-box;
	 -webkit-line-clamp: 4;
	 line-clamp: 4;
	 -webkit-box-orient: vertical;
}
.only-three{
	text-overflow: -o-ellipsis-lastline;
	 overflow: hidden;
	 text-overflow: ellipsis;
	 display: -webkit-box;
	 -webkit-line-clamp: 3;
	 line-clamp: 3;
	 -webkit-box-orient: vertical;
}

</style>



// WEBPACK FOOTER //
// src/App.vue